<template>
  <div class="notify-wrap">
    <div v-for="item in notify" :key="item.id" class="notify-item">
      <button @click="close(item.id)" class="btn-close" rel="button_close" type="button">
        <svg class="svg-cross">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <svg class="svg-icon">
        <use href="/img/sprite.svg#svg-comment"></use>
      </svg>
      <div class="notify-text">{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters('notify', [
      'notify',
    ]),
  },
  methods: {
    ...mapMutations('notify', [
      'close',
    ])
  }
}
</script>